/* eslint-disable */ 
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import Breadcrumbs from './components/bread_crumbs';
import { store } from './store';
import firebase from 'firebase/app';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import VueTour from 'vue-tour';
import Notifications from 'vue-notification';
import { Vue2Dragula } from 'vue2-dragula';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMasonryPlugin } from 'vue-masonry';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts';
import FunctionalCalendar from 'vue-functional-calendar';
import vueKanban from 'vue-kanban';
import excel from 'vue-excel-export'

/* ✅ Sentry Import */
import * as Sentry from "@sentry/vue";

/* import the fontawesome  */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {fas} from "@fortawesome/free-solid-svg-icons";
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon)


import PxCard  from './components/Pxcard.vue';
Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

// Multi Language Add
import en from './locales/en.json';
import es from './locales/es.json';
import { defaultLocale, localeOptions,googleMapApiKey } from './constants/config';
import VueI18n from 'vue-i18n';

// Import Theme scss
import './assets/scss/app.scss';

// config for firebase
import config from './config.json';

import Axios from 'axios';
import Endpoints from '@/config/ApiEndpoints.js';
window.axios = Axios
window.Endpoints = Endpoints;
window.enableVehicleInspection = true;

import Config from '@/config/Config.js';

window.pbx_SiteTitle = Config.SiteTitle
var Company = JSON.parse(localStorage.getItem('Company'))
if(Company && Company.name){	
	window.pbx_SiteTitle = Company.name
}

//var todaysUrgentTaskNew = false;
var isProd = false;

//window.todaysUrgentTaskNew = todaysUrgentTaskNew
window.todaysUrgentTaskNew = true

Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png')
});

Vue.use(VueFeather);
Vue.use(Vuelidate);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});
Vue.use(Vue2Dragula);

Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapApiKey,
    libraries: 'places',
  },
});

Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);
Vue.use(VueFormWizard);
Vue.use(VueTour);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(require('vue-chartist'));
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(VueMasonryPlugin);
Vue.component('apexchart', VueApexCharts);
Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
});
Vue.use(vueKanban);
Vue.use(VueI18n);
Vue.use(excel);

//window.taskModuleCompanies = [45,160,278,69,149,171,202,232,233,245,259,243,180,201,93,200,217,182,102,165,148,161,169,50,157,51,94,135,140,134,120,111,110,83,66,82,58,107,97,106,84,75,49,76,52,202,221,223,172,17,259,70,55,218,219,249,239,285,268,265,240,255,294,295,273,278,286,171,245,281,279,271,284,277,263,191,310,293,307,411,373,424,426,3,4,5,6,7,8,9,10,11,12,13,14,15,16,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,46,47,48,53,54,63,64,67,68,81,85,86,87,88,89,91,92,95,96,100,101,103,105,108,109,112,118,119,124,125,126,127,128,132,146,147,156,162,163,164,167,168,170,179,188,216,220,222,229,231,234,242,244,248,250,254,256,257,262,264,269,274,275,291,371,399,414,108,398,400,401,404,407,420,423,424,426,509];
window.taskModuleCompanies = [];

// setup fake backend
import { configureFakeBackend } from './_helpers';
configureFakeBackend();

const messages = { en: en, es: es };
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

Vue.config.productionTip = false;
firebase.initializeApp(config.firebase);

export const db = firebase.firestore();

/* ✅ SENTRY INITIALIZATION (GlitchTip) */
if (isProd) {
  Sentry.init({
    Vue,
    dsn: "https://6a2e4ac3455a432e92af800a4f556230@app.glitchtip.com/21410",
    release: "1.0.0",
    environment: "production",
    tracesSampleRate: 0.01,
    autoSessionTracking: false,
    logErrors: true,
  });
}

Axios.interceptors.response.use(
  function(successRes) {  	    
    return successRes;
  }, 
  function(error) {
  	if(error.response && error.response.status && error.response.status == 401){
  		localStorage.removeItem('token');
  		localStorage.removeItem('tokenExpiry');
		localStorage.removeItem('User');
		localStorage.removeItem('userinfo');
		localStorage.removeItem('loggedIn');
		localStorage.removeItem('islogged');
		window.location = '/';
  	} 
    return error;
  }
);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
